export const getAlignedFrfRows = (csvRows) => {
  if (!Array.isArray(csvRows)) {
    return [];
  }

  return csvRows
    .map((row) => {
      const frequency = Number(row?.[0]);
      const accelerationMagnitude = Number(row?.[3]);
      const phaseRadians = Number(row?.[4]);

      return {
        frequency,
        accelerationMagnitude,
        phaseRadians: Number.isFinite(phaseRadians) ? phaseRadians : 0
      };
    })
    .filter(({ frequency, accelerationMagnitude }) => (
      Number.isFinite(frequency)
      && frequency > 0
      && Number.isFinite(accelerationMagnitude)
    ));
};

export const buildFrfSeries = (csvRows) => {
  const alignedRows = getAlignedFrfRows(csvRows);
  const freq = alignedRows.map(({ frequency }) => frequency);
  const magn = alignedRows.map(({ frequency, accelerationMagnitude }) => {
    const velocityMagnitude = accelerationMagnitude / frequency * 1000 * 9.81 / (2 * Math.PI);
    return velocityMagnitude / frequency * 1000 / (2 * Math.PI);
  });

  return {
    freq,
    magn,
    phase: alignedRows.map(({ phaseRadians }) => phaseRadians * 180 / Math.PI),
    magdb: magn.map((magnitude) => 20 * Math.log10(magnitude))
  };
};
